import { cn } from "@/lib/utils/cn";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import * as React from "react";

const Popover = PopoverPrimitive.Root;

const PopoverAnchor = PopoverPrimitive.Anchor;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & {
    className?: string;
    align?: "start" | "center" | "end";
    sideOffset?: number;
    portalled?: boolean;
  }
>(
  (
    { className, align = "center", sideOffset = 4, portalled = true, ...props },
    ref,
  ) => {
    const content = (
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        collisionPadding={8}
        className={cn(
          "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[110] w-72 rounded-md border p-4 shadow-md outline-hidden",
          "max-h-[var(--radix-popover-content-available-height)] overflow-y-auto has-[[cmdk-root]]:flex has-[[cmdk-root]]:max-h-[min(24rem,var(--radix-popover-content-available-height))] has-[[cmdk-root]]:flex-col [&_[cmdk-input-wrapper]]:shrink-0 [&_[cmdk-list]]:max-h-none [&_[cmdk-list]]:min-h-0 [&_[cmdk-list]]:flex-1 [&_[cmdk-root]]:min-h-0 [&_[cmdk-root]]:flex-1",
          className,
        )}
        {...props}
      />
    );

    if (!portalled) {
      return content;
    }

    return <PopoverPrimitive.Portal>{content}</PopoverPrimitive.Portal>;
  },
);
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };
